import {Component, inject, Input, OnInit} from '@angular/core';
import {Company, CompanyBilling} from '@core/types';
import {CompanyService} from '@core/services';

@Component({
  selector: 'core-modal-company-info',
  standalone: true,
  templateUrl: './company-info.html',
  styleUrl: './company-info.scss',
  host: {
    style: 'width: 100%;display: flex;flex-direction: column;gap: 1.25rem;padding: 0 1.5rem 1.5rem'
  }
})
export class CompanyInfo implements OnInit {
  @Input() company: Company | null = null;
  @Input() companyId?: string | number;
  @Input() roleName = '';

  billing: CompanyBilling | null = null;
  billingLoading = false;
  billingError = '';

  private readonly companyService = inject(CompanyService);

  ngOnInit() {
    if (this.companyId) {
      this.loadBilling(this.companyId);
    }
  }

  get companyName() {
    return this.company?.name || 'Empresa';
  }

  get companyDescription() {
    return this.company?.description || '';
  }

  get companyTaxId() {
    return this.company?.taxId || '';
  }

  get companyCapital() {
    return this.company?.capital ?? null;
  }

  get countries() {
    return this.company?.countries || [];
  }

  private async loadBilling(companyId: string | number) {
    this.billingLoading = true;
    this.billingError = '';
    const response = await this.companyService.getBilling(companyId, {skipLoader: true});
    this.billingLoading = false;

    if (!response.success || !response.result) {
      this.billingError = response.message || 'No se pudieron cargar los datos de facturación.';
      return;
    }

    this.billing = response.result;
  }
}
